import { Box } from "@mui/material";
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import DeleteDivisionConfirmationDialog from "./deleteLevelConfirmationDialog";
import ReassignDepartmentDialog from "./reassignDivisionDialog";
import { useDivisionGrid } from "../hooks/useDivisionGrid";

function DivisionGrid({ handleEditOpen }) {
  const {
    backgroundAlt,
    primaryLight,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    sort,
    setSort,
    searchInput,
    setSearchInput,
    divisions,
    totalDivisions,
    deleteDivisionDialogOpen,
    reassignDivisionAssessmentsDialogOpen,
    setReassignDivisionAssessmentsDialogOpen,
    closeDeleteDialog,
    handleDeleteDivisionConfirm,
    handleReassignConfirm,
    columns,
    sortModel,
    setSortModel,
  } = useDivisionGrid({ handleEditOpen });

  return (
    <Box
      mt="40px"
      sx={{
        "& .MuiDataGrid-root": {},
        "& .MuiDataGrid-cell": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: primaryLight,
        },
        "& .MuiDataGrid-row": {
          height: "auto", // This ensures the row height adapts to content
        },
      }}
    >
      <DataGrid
        getRowId={(row) => row._id}
        rows={divisions}
        columns={columns}
        page={page - 1} // If API expects zero-based indexing
        pageSize={pageSize}
        rowCount={totalDivisions}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        onPageChange={(newPage) => {
          setPage(newPage + 1); // Convert zero-based to one-based if necessary
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(1); // Reset to first page when page size changes
          setPageSize(newPageSize);
        }}
        sortingMode="server" // Enable server-side sorting
        sortModel={sortModel}
        onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
        paginationMode="server"
        components={{
          Toolbar: DataGridCustomToolbar,
        }}
        componentsProps={{
          toolbar: {
            search,
            setSearch,
            searchInput,
            setSearchInput,
            sort,
            setSort,
          },
        }}
        disableSelectionOnClick
        rowHeight={50}
        autoHeight
      />
      <DeleteDivisionConfirmationDialog
        open={deleteDivisionDialogOpen}
        handleClose={closeDeleteDialog}
        handleDeleteDivisionConfirm={handleDeleteDivisionConfirm}
      />

      <ReassignDepartmentDialog
        open={reassignDivisionAssessmentsDialogOpen}
        handleClose={() => setReassignDivisionAssessmentsDialogOpen(false)}
        handleReassignConfirm={handleReassignConfirm}
      />
    </Box>
  );
}

export default DivisionGrid;
